import { createContext } from 'react';

export const defaultDialogHeaderContext: {
  isDialogHeader: boolean;
} = {
  isDialogHeader: false,
};

export const DialogHeaderContext = createContext(defaultDialogHeaderContext);

const { Provider } = DialogHeaderContext;

export { Provider as DialogHeaderContextProvider };
